
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.b701584598 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a97649450 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b853926422 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a181209969 = numberParserFn([{",":".",".":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.b11573794 = pluralGeneratorFn(function(n
) {
  return (n == 1) ? 'one' : 'other';
});
Globalize.a543156756 = messageFormatterFn((function(  ) {
  return function(d) { return "Giriş Yap"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1256515402 = messageFormatterFn((function(  ) {
  return function(d) { return "Giriş yap"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1577913227 = messageFormatterFn((function(  ) {
  return function(d) { return "E-posta adresi"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1070761788 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifre"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1392853091 = messageFormatterFn((function(  ) {
  return function(d) { return "Bu herkese açık veya paylaşılan bir cihaz"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1718189156 = messageFormatterFn((function(  ) {
  return function(d) { return "Cihaz sizin değil mi? Bu onay kutusunu işaretlemek, cihazda oturumunuzun açık kalacağı süreyi azaltır."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b801554633 = messageFormatterFn((function(  ) {
  return function(d) { return "Oturumumu açık tut"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b369907175 = messageFormatterFn((function(  ) {
  return function(d) { return "Bu onay kutusunu seçtiğinizde, siz çıkış yapana kadar hesabınız bu cihazda açık kalacak. Bunu paylaşılan cihazlarda seçmeyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2110861791 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifrenizi mi unuttunuz?"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a729292496 = messageFormatterFn((function(  ) {
  return function(d) { return "Devam et"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b415225949 = messageFormatterFn((function(  ) {
  return function(d) { return "İptal et"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1618914298 = messageFormatterFn((function(  ) {
  return function(d) { return "Geri git"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1595030776 = messageFormatterFn((function(  ) {
  return function(d) { return "Tekrar yükle"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1574850637 = messageFormatterFn((function(  ) {
  return function(d) { return "İmzalayarak " + d["0"] + " <a href=" + d["1"] + " " + d["3"] + ">Hükümleri ve Koşulları</a>’nı ve <a href=" + d["2"] + " " + d["4"] + ">Gizlilik Bildirimi</a>’ni kabul ediyorum."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b155048651 = messageFormatterFn((function(  ) {
  return function(d) { return "İmzalayarak " + d["0"] + " <a href=" + d["1"] + " " + d["5"] + ">Hükümleri ve Koşulları</a>'nı, <a href=" + d["2"] + " " + d["6"] + ">Gizlilik Bildirimi</a>’ni, <a href=" + d["3"] + " " + d["7"] + ">" + d["4"] + " Hükümleri ve Koşulları</a>’nı kabul ediyorum."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a403344515 = messageFormatterFn((function(  ) {
  return function(d) { return "İmzalayarak " + d["4"] + " programına da katılıyorum. " + d["0"] + " <a href=" + d["1"] + " " + d["5"] + ">Hükümleri ve Koşulları</a>'nı, <a href=" + d["2"] + " " + d["6"] + ">Gizlilik Bildirimi</a>’ni ve <a href=" + d["3"] + " " + d["7"] + ">" + d["4"] + " Hükümleri ve Koşulları</a>’nı kabul ediyorum."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b56144168 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesabınız, rutin bir güvenlik kontrolü sırasında duraklatıldı. Bilgileriniz güvende ancak şifrenizi sıfırlamanız gerekiyor. Giriş yapmak için aşağıdaki \"Şifrenizi mi unuttunuz?\" bağlantısıyla şifre değişikliğini yapın."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1592670318 = messageFormatterFn((function(  ) {
  return function(d) { return "E-posta ve şifre eşleşmiyor. Lütfen tekrar deneyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a587255817 = messageFormatterFn((function(  ) {
  return function(d) { return "Özür dileriz, bizim tarafımızda bir sorun oluştu."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1432795185 = messageFormatterFn((function(  ) {
  return function(d) { return "Özür dileriz, bizden kaynaklanan bir sorun oluştu. Lütfen biraz bekleyip tekrar deneyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1891064301 = messageFormatterFn((function(  ) {
  return function(d) { return "Lütfen e-posta adresinizi girin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b266622594 = messageFormatterFn((function(  ) {
  return function(d) { return "Geçerli bir e-posta adresi girin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1085530308 = messageFormatterFn((function(  ) {
  return function(d) { return "Lütfen şifrenizi girin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2051640550 = messageFormatterFn((function(  ) {
  return function(d) { return "Giriş bilgileri kontrol ediliyor"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b813155937 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifreyi gizle"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b498813798 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifreyi göster"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1086914716 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesabınız yok mu? <span><a id=\"createAcctRedirectLink\" href=" + d["0"] + ">Hesap oluşturun</a></span>"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2133594455 = messageFormatterFn((function(  ) {
  return function(d) { return "Giriş yap"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b15697632 = messageFormatterFn((function(  ) {
  return function(d) { return "Artık " + d["0"] + " ile giriş yapılamaz"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1084632060 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifreyi sıfırlayarak " + d["0"] + " hesabınıza erişmek için aynı e-postayı kullanabilirsiniz. Bu, " + d["1"] + " hesabınızı etkilemeyecek."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a676820530 = messageFormatterFn((function(  ) {
  return function(d) { return "Aşağıdaki düğmeyi kullanarak şifrenizi sıfırlayın. Bir sonraki sefer e-postanızı ve yeni şifrenizi kullanarak " + d["0"] + " için doğrudan giriş yapın."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a151088683 = messageFormatterFn((function(  ) {
  return function(d) { return "SSO giriş yap"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b71265229 = messageFormatterFn((function(  ) {
  return function(d) { return "Çoklu oturum açmayı kullanarak giriş yap"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b681704927 = messageFormatterFn((function(  ) {
  return function(d) { return "Veya " + d["0"] + " hesabınızı kullanın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a866403412 = messageFormatterFn((function(  ) {
  return function(d) { return "Ücretsiz seyahat için puan kazanın. Üye indirimleriyle tasarruf edin. Seyahat programınıza kolayca erişin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a448660846 = messageFormatterFn((function(  ) {
  return function(d) { return "Bu seyahatten sonra " + d["0"] + " Expedia Rewards puanı kazanın."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a605330485 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " Hesap Girişi"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b443528307 = messageFormatterFn((function(  ) {
  return function(d) { return "yeni sekmede açılır"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b149814801 = messageFormatterFn((function(  ) {
  return function(d) { return "Hükümler ve Koşullarımızı (" + d["0"] + ")"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1606769777 = messageFormatterFn((function(  ) {
  return function(d) { return "Gizlilik Bildirimimizi (" + d["0"] + ")"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1276589972 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key Ödül Programı Hükümlerini ve Koşullarını (" + d["0"] + ") "; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a630219977 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifremi Unuttum"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2075239950 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifrenizi sıfırlayın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1829808344 = messageFormatterFn((function(  ) {
  return function(d) { return "E-postanızı girerseniz size şifrenizi sıfırlama bağlantısını gönderebiliriz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a158969748 = messageFormatterFn((function(  ) {
  return function(d) { return "Sıfırlama bağlantısını gönder"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1495919311 = messageFormatterFn((function(  ) {
  return function(d) { return "Gelen kutunuzu kontrol edin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1127409527 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " adresine şifrenizi sıfırlama bağlantısını içeren bir e-posta gönderdik."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1127410488 = messageFormatterFn((function(  ) {
  return function(d) { return "E-postanın ulaşması birkaç dakika sürebilir. 10 dakika sonra gelen bir e-posta görmezseniz önemsiz veya istenmeyen posta klasörünüzü kontrol edin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a640968670 = messageFormatterFn((function(  ) {
  return function(d) { return "Bağlantıyı yeniden gönder"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2145257242 = messageFormatterFn((function(  ) {
  return function(d) { return "Yeni bir bağlantı gönderildi."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1577558771 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesap doğrulanıyor"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1134522573 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifre Belirleyin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b970364060 = messageFormatterFn((function(  ) {
  return function(d) { return "Geri dönmenize sevindik"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1424874434 = messageFormatterFn((function(  ) {
  return function(d) { return "Devam etmek için benzersiz bir şifre oluşturun"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1028363661 = messageFormatterFn((function(  ) {
  return function(d) { return "Başarılı!"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1569370582 = messageFormatterFn((function(  ) {
  return function(d) { return "Bundan sonra yeni şifrenizi kullanın."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b713319973 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifreyi sıfırlayın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a424378306 = messageFormatterFn((function(  ) {
  return function(d) { return "Maalesef bu isteğin süresi doldu. Hâlâ şifrenizi değiştirmeniz gerekiyorsa lütfen aşağıya tıklayarak yeni bir şifre sıfırlama e-postası gönderin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1272302930 = messageFormatterFn((function(  ) {
  return function(d) { return "Bağlantıyı yeniden gönder"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a295451133 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifreniz kaydediliyor"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a258954671 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesap oluşturun"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1026776285 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesap oluşturun"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1128140654 = messageFormatterFn((function(  ) {
  return function(d) { return "E-posta adresi"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a862683110 = messageFormatterFn((function(  ) {
  return function(d) { return "Lütfen e-posta adresinizi girin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1702879561 = messageFormatterFn((function(  ) {
  return function(d) { return "Geçerli bir e-posta adresi girin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a667818381 = messageFormatterFn((function(  ) {
  return function(d) { return "Adı"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1784581637 = messageFormatterFn((function(  ) {
  return function(d) { return "Lütfen adınızı girin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1888846001 = messageFormatterFn((function(  ) {
  return function(d) { return "Soyadı"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a677944633 = messageFormatterFn((function(  ) {
  return function(d) { return "Lütfen soyadınızı girin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b308321742 = messageFormatterFn((function(  ) {
  return function(d) { return "Adı yalnızca harf kullanarak girin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1555738837 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifre"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1528327091 = messageFormatterFn((function(  ) {
  return function(d) { return "Lütfen şifrenizi girin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b206172350 = messageFormatterFn((function(  ) {
  return function(d) { return "Lütfen geçerli bir şifre girin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1738325310 = messageFormatterFn((function(  ) {
  return function(d) { return "9-64 karakter içerir"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1738326271 = messageFormatterFn((function(  ) {
  return function(d) { return "Harfler ve sayılar bir arada bulunur"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1738327232 = messageFormatterFn((function(  ) {
  return function(d) { return "~ " + "#" + " @ $ % & ! * _ ? ^ - gibi özel karakter içerir"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1738328193 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifre boşluk içeremez"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a139716472 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifreniz 8-64 karakter arasında olmalıdır"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2077137317 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifre, e-posta adresinizle aynı olamaz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1227259358 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifre boşluk içeremez."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b199193638 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesap oluşturarak " + d["0"] + " <a href=" + d["1"] + " " + d["3"] + ">Hükümleri ve Koşulları</a>’nı ve <a href=" + d["2"] + " " + d["4"] + ">Gizlilik Bildirimi</a>’ni kabul ediyorum."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1604331832 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesap oluşturarak " + d["0"] + " <a href=" + d["1"] + " " + d["5"] + ">Hükümleri ve Koşulları</a>'nı, <a href=" + d["2"] + " " + d["6"] + ">Gizlilik Bildirimi</a>’ni ve <a href=" + d["3"] + " " + d["7"] + ">" + d["4"] + " Hükümleri ve Koşulları</a>’nı kabul ediyorum."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1837911063 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " firmasından e-posta yoluyla seyahat fırsatları, özel teklifleri ve diğer bilgileri almak istiyorum."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b910208730 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " firmasından e-posta yoluyla seyahat fırsatları, özel teklifleri ve diğer bilgileri almak istiyorum. Promosyon e-postalarından istediğiniz zaman çıkabilirsiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1988808212 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " firmasından e-posta yoluyla tatil fikirleri, özel teklifleri ve diğer bilgileri almak istiyorum."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b885788669 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " firmasından e-posta yoluyla tatil fikirleri, özel teklifleri ve diğer bilgileri almak istiyorum. Promosyon e-postalarından istediğiniz zaman çıkabilirsiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a244315447 = messageFormatterFn((function(  ) {
  return function(d) { return "Devam et"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a86219068 = messageFormatterFn((function(  ) {
  return function(d) { return "Zaten hesabınız var mı? <span><a id=\"signinRedirectLink\" href=" + d["0"] + ">Giriş yap</a></span>"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a824401473 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoş geldiniz, " + d["0"]; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1501749659 = messageFormatterFn((function(  ) {
  return function(d) { return "Yeni " + d["0"] + " hesabınızla tüm dünya ulaşabileceğiniz mesafede olacak."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a219314030 = messageFormatterFn((function(  ) {
  return function(d) { return "Devam et"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b268467805 = messageFormatterFn((function(  ) {
  return function(d) { return "Devam etmek için şifreniz daha güçlü olmalıdır"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1444927128 = messageFormatterFn((function(  ) {
  return function(d) { return "En az 8 karakter içermelidir."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1781057676 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifre gücü"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1147978698 = messageFormatterFn((function(  ) {
  return function(d) { return "Zayıf"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1156889899 = messageFormatterFn((function(  ) {
  return function(d) { return "Güçlü"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1481950379 = messageFormatterFn((function(  ) {
  return function(d) { return "Çok Güçlü"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a619041562 = messageFormatterFn((function(  ) {
  return function(d) { return "\"a\" yerine \"@\" gibi öngörülebilir harf değişimlerinden kaçının."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b780326654 = messageFormatterFn((function(  ) {
  return function(d) { return "Sık kullanılan kelimelerin ters yazılmasından kaçının."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1128878262 = messageFormatterFn((function(  ) {
  return function(d) { return "Harflerin bazılarını büyük yazın, tüm harfleri değil."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a957252311 = messageFormatterFn((function(  ) {
  return function(d) { return "İlk harften daha fazla yerde büyük harf kullanın."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1781777701 = messageFormatterFn((function(  ) {
  return function(d) { return "Sizinle ilişkili tarihlerden ve yıllardan kaçının."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a246076315 = messageFormatterFn((function(  ) {
  return function(d) { return "Son yıllardan kaçının."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b958124490 = messageFormatterFn((function(  ) {
  return function(d) { return "Sizinle ilişkili yıllardan kaçının."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2097556873 = messageFormatterFn((function(  ) {
  return function(d) { return "Yaygın karakter dizilerinden kaçının."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1465113745 = messageFormatterFn((function(  ) {
  return function(d) { return "Tekrarlanan kelime ve karakterlerden kaçının."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1100569803 = messageFormatterFn((function(  ) {
  return function(d) { return "Daha uzun klavye örüntüleri kullanın ve yazma yönünü birçok kez değiştirin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1331672038 = messageFormatterFn((function(  ) {
  return function(d) { return "Daha az yaygın olan daha fazla kelime ekleyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b667965178 = messageFormatterFn((function(  ) {
  return function(d) { return "Birden çok kelime kullanın ancak yaygın ifadelerden kaçının."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a53932521 = messageFormatterFn((function(  ) {
  return function(d) { return "Semboller, sayılar veya büyük harfler kullanmadan güçlü şifreler oluşturabilirsiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1031713104 = messageFormatterFn((function(  ) {
  return function(d) { return "Bu e-posta adresi zaten " + d["0"] + " üzerindeki bir hesapla ilişkilendirilmiş"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1613396322 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesabınızın oluşturulmasını tamamlamak için size e-posta yoluyla bir bağlantı gönderdik."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b953034803 = messageFormatterFn((function(  ) {
  return function(d) { return "Kayıt isteği devam ediyor"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b964609351 = messageFormatterFn((function(  ) {
  return function(d) { return "Ad en az iki karakterden oluşmalıdır"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1713457899 = messageFormatterFn((function(  ) {
  return function(d) { return "Soyadı en az iki karakterden oluşmalıdır"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a283440487 = messageFormatterFn((function(  ) {
  return function(d) { return "Ad en fazla 100 karakter uzunluğunda olabilir"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b465408061 = messageFormatterFn((function(  ) {
  return function(d) { return "Soyadı en fazla 100 karakter uzunluğunda olabilir"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2069889374 = messageFormatterFn((function(  ) {
  return function(d) { return "Ad özel karakterler içeremez"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b158838274 = messageFormatterFn((function(  ) {
  return function(d) { return "Soyadı özel karakterler içeremez"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1205163648 = messageFormatterFn((function(  ) {
  return function(d) { return "Aşağıdakilerin tümünü kabul ediyorum"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1197592436 = messageFormatterFn((function(  ) {
  return function(d) { return "18 yaşında veya daha büyük olduğumu, <a href=" + d["0"] + " " + d["1"] + ">Kullanım Hükümleri ve Koşulları</a> ve <a href=" + d["2"] + " " + d["3"] + ">" + d["4"] + " Hükümler ve Koşullar</a> belgelerini inceleyip kabul ettiğimi onaylıyorum (gerekli)"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a261871670 = messageFormatterFn((function(  ) {
  return function(d) { return "Kişisel bilgilerimin <a href=" + d["0"] + " " + d["1"] + ">Gizlilik Politikası</a>'nda belirtildiği şekilde toplanıp kullanılmasına izin veriyorum (gerekli)"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1858946007 = messageFormatterFn((function(  ) {
  return function(d) { return "Kişisel bilgilerimin <a href=" + d["0"] + " " + d["1"] + ">Gizlilik Politikası</a>'nda belirtildiği şekilde, Kore'deki veya yurt dışındaki üçüncü taraflara sağlanmasına izin veriyorum (gerekli)"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1674020756 = messageFormatterFn((function(  ) {
  return function(d) { return "Devam etmek için lütfen koşulları kabul edin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1797570288 = messageFormatterFn((function(  ) {
  return function(d) { return "Devam etmek için Koşulları kabul edin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1191067916 = messageFormatterFn((function(  ) {
  return function(d) { return "Devam etmek için kutuyu işaretleyin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1027496453 = messageFormatterFn((function(  ) {
  return function(d) { return "Veya bir " + d["0"] + " hesabı oluşturun"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a65399961 = messageFormatterFn((function(  ) {
  return function(d) { return "Boşluk karakterini, adınızı, e-posta adresinizi veya daha önce kullandığınız şifreleri kullanmamaya özen gösterin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1562032611 = messageFormatterFn((function(  ) {
  return function(d) { return "Özür dileriz, bizden kaynaklanan bir sorun oluştu. Lütfen birkaç dakika bekledikten sonra tekrar deneyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a161055881 = messageFormatterFn((function(  ) {
  return function(d) { return "Cep telefonu numaranızı doğrulayın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a566558010 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesabınızın güvenliğini sağlamak için cep telefonu numaranıza tek seferlik bir doğrulama kodu göndereceğiz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b748052243 = messageFormatterFn((function(  ) {
  return function(d) { return "Gönder"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2054587642 = messageFormatterFn((function(  ) {
  return function(d) { return "© " + d["1"] + " " + d["0"] + " Tüm hakları saklıdır."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a575205448 = messageFormatterFn((function(  ) {
  return function(d) { return "Hükümler ve Koşullar"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b611359607 = messageFormatterFn((function(  ) {
  return function(d) { return "Gizlilik Politikası"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1319341792 = messageFormatterFn((function(  ) {
  return function(d) { return "Bana kısa mesaj atın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1859654347 = messageFormatterFn((function(  ) {
  return function(d) { return "Doğrulama kodunu girin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1786076441 = messageFormatterFn((function(  ) {
  return function(d) { return "Doğrulama kodu"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1215085786 = messageFormatterFn((function(  ) {
  return function(d) { return "Kodu tekrar gönder"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a216965873 = messageFormatterFn((function(  ) {
  return function(d) { return "Cep telefonu numarasını değiştir"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b32831261 = messageFormatterFn((function(  ) {
  return function(d) { return "Doğrulama kodu tekrar gönderildi."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a830673476 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " numaralı telefona gönderdiğimiz 6 haneli doğrulama kodunu girin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1242602359 = messageFormatterFn((function(  ) {
  return function(d) { return "Doğrulama kodu kontrol ediliyor"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b206145378 = messageFormatterFn((function(  ) {
  return function(d) { return "Bu kod yanlış. Tekrar denemek için yeniden kod alın."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b461139608 = messageFormatterFn((function(  ) {
  return function(d) { return "veya şu yöntemle devam edin:"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1217351816 = messageFormatterFn((function(  ) {
  return function(d) { return "Üye olarak binlerce otelde ortalama %" + d["0"] + " tasarruf edin; üyelik her zaman ücretsizdir."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1351112454 = messageFormatterFn((function(  ) {
  return function(d) { return "veya"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1697828220 = messageFormatterFn((function(  ) {
  return function(d) { return "Giriş yapmanın diğer yolları"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1697468806 = messageFormatterFn((function(  ) {
  return function(d) { return "Kaydolmanın diğer yolları"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b164429296 = messageFormatterFn((function(  ) {
  return function(d) { return "Google ile kaydol"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a30728687 = messageFormatterFn((function(  ) {
  return function(d) { return "Giriş yapılamadı. Devam etmek için lütfen tekrar deneyin veya bu sitede bir hesap oluşturun."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1351858281 = messageFormatterFn((function(  ) {
  return function(d) { return "Telefon aracılığıyla oturum açılamıyor. Sosyal hesabınızın e-posta adresinizi paylaşacak şekilde ayarlandığından emin olun"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2010386273 = messageFormatterFn((function(  ) {
  return function(d) { return "Üye olarak binlerce otelde %" + d["0"] + " tasarruf edin; üyelik her zaman ücretsizdir."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1796791878 = messageFormatterFn((function(  ) {
  return function(d) { return "Google'la giriş yap"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1750996091 = messageFormatterFn((function(  ) {
  return function(d) { return "NAVER ile giriş yapın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1847592987 = messageFormatterFn((function(  ) {
  return function(d) { return "Maksimum giriş denemesi sayısını aştınız. Lütfen daha sonra tekrar deneyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a575384760 = messageFormatterFn((function(  ) {
  return function(d) { return "Biyometrik bilgilerinizle giriş yapın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a845929576 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifrenizi yazmaya gerek kalmadan biyometrik bilgilerinizi kullanarak hesabınıza erişin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a793558997 = messageFormatterFn((function(  ) {
  return function(d) { return "Başla"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1214450885 = messageFormatterFn((function(  ) {
  return function(d) { return "Daha sonra hatırlat"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1520503151 = messageFormatterFn((function(  ) {
  return function(d) { return "Başarılı!"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1116740053 = messageFormatterFn((function(  ) {
  return function(d) { return "Biyometrik giriş etkinleştirildi."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a542270227 = messageFormatterFn((function(  ) {
  return function(d) { return "Biyometrik bilgilerle giriş yap"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1173928088 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifre kullan"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1578707005 = messageFormatterFn((function(  ) {
  return function(d) { return "Biyometrik bilgileri kullan"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1211894250 = messageFormatterFn((function(  ) {
  return function(d) { return "Devam etmek için şifrenizi güncelleyin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1279741742 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesabınıza erişmek için şifre sıfırlama gereklidir."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1573039752 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifreyi sıfırlayın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a3235976 = messageFormatterFn((function(  ) {
  return function(d) { return "Artık üye avantajlarından yararlanabilirsiniz"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1466533970 = messageFormatterFn((function(  ) {
  return function(d) { return "Bir sonraki maceranıza $" + d["0"] + " tutarında hediye puanımızla başlayın!"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2089646270 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesabınızda görebileceğiniz bu puanları ilk rezervasyonunuzda kullanabilirsiniz. Yapmanız gereken tek şey, ödeme sayfasındaki puan uygulama seçeneğini bulmak."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b858024592 = messageFormatterFn((function(  ) {
  return function(d) { return "Artık bir Expedia üyesisiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b405724736 = messageFormatterFn((function(  ) {
  return function(d) { return "Üyelere Özel Fiyatlar ile anında kazanç sağlamaya başlayın ve rezervasyon yaptığınızda puan kazanın."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2012507467 = messageFormatterFn((function(  ) {
  return function(d) { return "Giriş yapın veya hesap oluşturun"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1386967045 = messageFormatterFn((function(  ) {
  return function(d) { return "Üye olarak binlerce otelde ortalama %" + d["0"] + " tasarruf edin; üyelik her zaman ücretsizdir."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b350048355 = messageFormatterFn((function(  ) {
  return function(d) { return "Devam ederek, <a href=" + d["1"] + " " + d["3"] + ">Hükümler ve Koşullarımızı</a> ve <a href=" + d["2"] + " " + d["4"] + ">Gizlilik Bildirimimizi</a> okuyup kabul etmiş olursunuz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b81844251 = messageFormatterFn((function(  ) {
  return function(d) { return "Devam ederek, <a href=" + d["1"] + " " + d["5"] + ">Hükümler ve Koşullarımızı</a>, <a href=" + d["2"] + " " + d["6"] + ">Gizlilik Bildirimimizi</a> ve <a href=" + d["3"] + " " + d["7"] + ">" + d["4"] + " Hükümlerini ve Koşullarını</a> okuyup kabul etmiş olursunuz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b70793920 = messageFormatterFn((function(  ) {
  return function(d) { return "Devam ederek, <a href=" + d["1"] + " " + d["4"] + ">Hükümler ve Koşullarımızı</a>, <a href=" + d["2"] + " " + d["5"] + ">Gizlilik Bildirimimizi</a> ve <a href=" + d["3"] + " " + d["6"] + ">One Key Ödül Programı Hükümlerini ve Koşullarını</a> okuyup kabul etmiş olursunuz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a575737508 = messageFormatterFn((function(  ) {
  return function(d) { return "E-posta"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a842618846 = messageFormatterFn((function(  ) {
  return function(d) { return "Geçerli bir e-posta adresi girin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2029853983 = messageFormatterFn((function(  ) {
  return function(d) { return "Google"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1762871534 = messageFormatterFn((function(  ) {
  return function(d) { return "Facebook"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1342935736 = messageFormatterFn((function(  ) {
  return function(d) { return "Apple"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1170742433 = messageFormatterFn((function(  ) {
  return function(d) { return "Sadece kişisel cihazlar içindir. Hesabınızı güvenli tutmak için bunu başka cihazlarda işaretlemeyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b794647186 = messageFormatterFn((function(  ) {
  return function(d) { return "Çok sayıda giriş denemesinde bulundunuz. Tekrar denemeden önce " + d["0"] + " dakika beklemeniz gerekmektedir."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1975201866 = messageFormatterFn((function(  ) {
  return function(d) { return "Çok sayıda giriş denemesinde bulundunuz. Tekrar denemeden önce " + d["0"] + " dakika beklemeniz gerekmektedir."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1970306532 = messageFormatterFn((function(  ) {
  return function(d) { return "Çok sayıda giriş denemesinde bulundunuz. Tekrar denemeden önce " + d["0"] + " dakika beklemeniz gerekmektedir."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1983764376 = messageFormatterFn((function(  ) {
  return function(d) { return "Çok sayıda giriş denemesinde bulundunuz. Tekrar denemeden önce " + d["0"] + " dakika beklemeniz gerekmektedir."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1170629787 = messageFormatterFn((function(  ) {
  return function(d) { return "Çok sayıda giriş denemesinde bulundunuz. Tekrar denemeden önce " + d["0"] + " dakika beklemeniz gerekmektedir."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a383114400 = messageFormatterFn((function(  ) {
  return function(d) { return "Çok sayıda giriş denemesinde bulundunuz. Tekrar denemeden önce " + d["0"] + " dakika beklemeniz gerekmektedir."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1336084849 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia, Hotels.com ve Vrbo'da tek bir hesapla ödüller dünyasına adım atın."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b75244343 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia, Hotels.com ve Vrbo'da tek bir hesapla seyahat dünyasının kapılarını açın."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a326902608 = messageFormatterFn((function(  ) {
  return function(d) { return "Konaklama yerlerini inceleyip kaydedin, grubunuzla plan yapın ve rezervasyon detaylarınıza erişin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1892430671 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesabınız, rutin bir güvenlik kontrolü sırasında duraklatıldı. Bilgileriniz güvende ancak şifrenizi sıfırlamanız gerekiyor."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1719112001 = messageFormatterFn((function(  ) {
  return function(d) { return "OneKeyCash kazanmak için oturum açın ve konaklama rezervasyonunuzu yapın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2110358733 = messageFormatterFn((function(  ) {
  return function(d) { return "İşlemi sizin yaptığınızdan emin olalım"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1712271673 = messageFormatterFn((function(  ) {
  return function(d) { return "E-postanıza gönderdiğimiz güvenlik kodunu girin. Gelen kutunuzda göremiyorsanız önemsiz e-posta klasörünü kontrol edin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1860913851 = messageFormatterFn((function(  ) {
  return function(d) { return "Birlikte e-postanızı doğrulayalım"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b793214091 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " adresine gönderdiğimiz güvenlik kodunu girin. Gelen kutunuzda göremiyorsanız önemsiz e-posta klasörünü kontrol edin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1453475697 = messageFormatterFn((function(  ) {
  return function(d) { return "6 haneli kod"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2083177073 = messageFormatterFn((function(  ) {
  return function(d) { return "Kodu tekrar gönder"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1607158792 = messageFormatterFn((function(  ) {
  return function(d) { return "(0:" + d["0"] + ")"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2072518864 = messageFormatterFn((function(  ) {
  return function(d) { return "Kodu " + d["0"] + " saniye içinde tekrar gönder"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1977403104 = messageFormatterFn((function(  ) {
  return function(d) { return "E-posta almadınız mı?"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b42975106 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " sn. içinde başka bir kod talep edebilirsiniz"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b648715925 = messageFormatterFn((function(  ) {
  return function(d) { return "Başka bir kod talep et"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a110650421 = messageFormatterFn((function(  ) {
  return function(d) { return "Gelen kutunuza 6 haneli yeni bir kod gönderdik."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1647041088 = messageFormatterFn((function(  ) {
  return function(d) { return "Bunun yerine şifreyi girin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2001300351 = messageFormatterFn((function(  ) {
  return function(d) { return "Geçersiz kod, lütfen tekrar deneyin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1185168303 = messageFormatterFn((function(  ) {
  return function(d) { return "Kodun süresi doldu, lütfen yeniden gönderip tekrar deneyin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1368354596 = messageFormatterFn((function(  ) {
  return function(d) { return "Gelen kutunuzda göremiyorsanız önemsiz e-posta klasörünü kontrol edin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b520286069 = messageFormatterFn((function(  ) {
  return function(d) { return "Deneyimimizde güncellemeler yaptık ve e-posta adresinizi doğrulamamız gerekiyor. Gelen kutunuza gönderdiğimiz güvenlik kodunu girin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b743887212 = messageFormatterFn((function(  ) {
  return function(d) { return "Bizim tarafımızda bir sorun oluştu. Lütfen tekrar deneyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a185782109 = messageFormatterFn((function(  ) {
  return function(d) { return "Giriş yönteminizi güncellemek için e-postanıza gönderdiğimiz güvenlik kodunu girin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a36511753 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifrenizi girin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b473469630 = messageFormatterFn((function(  ) {
  return function(d) { return "E-posta yoluyla güvenli kod gönder"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1242095394 = messageFormatterFn((function(  ) {
  return function(d) { return "E-posta adresi ve şifre eşleşmiyor."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b575796313 = messageFormatterFn((function(  ) {
  return function(d) { return "Bir şifre oluşturun"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1202956900 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifre oluşturun | " + d["0"]; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1656897583 = messageFormatterFn((function(  ) {
  return function(d) { return "Bir şifre oluşturun"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b323297943 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia, Hotels.com ve Vrbo sitelerine giriş yapmak için aynı e-posta ve şifreyi kullanabilirsiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1868924137 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifre oluştur"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1854732186 = messageFormatterFn((function(  ) {
  return function(d) { return "Diğer güvenli giriş yöntemlerine ek olarak kullanılacak bir şifre belirleyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1756258459 = messageFormatterFn((function(  ) {
  return function(d) { return "Yeni şifre belirleyin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b320790488 = messageFormatterFn((function(  ) {
  return function(d) { return "Yeni şifre belirleyin | " + d["0"]; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1769777093 = messageFormatterFn((function(  ) {
  return function(d) { return "Yeni şifre belirleyin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a959283445 = messageFormatterFn((function(  ) {
  return function(d) { return "Artık Expedia, Hotels.com ve Vrbo'ya giriş yapmak için tek bir hesap kullanabilirsiniz. Birleştirilmiş hesabınız için yeni bir güvenli şifre oluşturun."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b515859445 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifre oluştur"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1810556669 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifreyi değiştirin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1162467194 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifrenizi değiştirin | " + d["0"]; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a739223507 = messageFormatterFn((function(  ) {
  return function(d) { return "Özgün ve güçlü bir parola kullanın."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2093588589 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifreyi güncelle"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a766948442 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifrenizi değiştiremedik. Lütfen tekrar deneyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1802353912 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifremi unuttum"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a792689378 = messageFormatterFn((function(  ) {
  return function(d) { return "Şifrenizi girin, oturum açmanız için size bir güvenlik kodu gönderelim"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1462484734 = messageFormatterFn((function(  ) {
  return function(d) { return "E-posta gönder"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b420536758 = messageFormatterFn((function(  ) {
  return function(d) { return "Bize ulaşın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a426265061 = messageFormatterFn((function(  ) {
  return function(d) { return "Veri sil"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a954010842 = messageFormatterFn((function(  ) {
  return function(d) { return "Kapat"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b439890178 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesabınızı kontrol ederken lütfen bekleyin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1604259969 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesabı sil"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b841103387 = messageFormatterFn((function(  ) {
  return function(d) { return "Anladım"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a252665791 = messageFormatterFn((function(  ) {
  return function(d) { return "Üzgünüz, seyahatiniz tamamlanana kadar hesabınızı silemezsiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b271162720 = messageFormatterFn((function(  ) {
  return function(d) { return "Son dakika değişiklikleri olması halinde rezervasyonunuza erişim sağlamanız ve müşteri hizmetlerinden yardım almanız için hesabınıza ihtiyacınız olacaktır. Bu erişim imkanı, seyahatinizin sorunsuz geçmesi için gereklidir."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1630553843 = messageFormatterFn((function(  ) {
  return function(d) { return "Üzgünüz, önce Vrbo otel sahibi hesabınızı silmeniz gerekecek"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b687304348 = messageFormatterFn((function(  ) {
  return function(d) { return "Süreci başlatmak üzere doğrudan müşteri hizmetlerimizle irtibata geçmek için lütfen internet sitesindeki veya uygulamadaki Yardım merkezimizi ziyaret edin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a717021076 = messageFormatterFn((function(  ) {
  return function(d) { return "Lütfen seyahatinizi tamamladıktan sonra yeniden deneyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1569965647 = messageFormatterFn((function(  ) {
  return function(d) { return "Neden ayrıldığınızı bizimle paylaşın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b404786242 = messageFormatterFn((function(  ) {
  return function(d) { return "Çok fazla e-posta veya bildirim alıyorum"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b972248236 = messageFormatterFn((function(  ) {
  return function(d) { return "Başka bir " + d["0"] + " hesabım var"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a733816975 = messageFormatterFn((function(  ) {
  return function(d) { return "Seyahatim sona erdi, artık bu hesaba ihtiyacım yok"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1153361429 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ile rezervasyon yaparken olumsuz bir deneyim yaşadım."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b442151894 = messageFormatterFn((function(  ) {
  return function(d) { return "Diğer"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1422305453 = messageFormatterFn((function(  ) {
  return function(d) { return "Atla"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1194725146 = messageFormatterFn((function(  ) {
  return function(d) { return "Gönder"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b905335254 = messageFormatterFn((function(  ) {
  return function(d) { return "Aramızdan ayrıldığınız için üzgünüz. Bilmeniz gereken birkaç ayrıntıyı aşağıda bulabilirsiniz:"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a444777891 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " değerinde " + d["0"] + " Expedia Ödül puanınızı, " + d["2"] + " değerinde kredinizi, kuponlarınızı, kayıtlı seyahat öğelerinizi ve hesap tercihlerinizi kalıcı olarak kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2011332690 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " değerinde " + d["0"] + " Expedia Ödül puanınızı, kuponlarınızı, kayıtlı seyahat öğelerinizi ve hesap tercihlerinizi kalıcı olarak kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1811592752 = messageFormatterFn((function(  ) {
  return function(d) { return "Seyahatteki biniş bilgilerinizi, kredilerinizi ve tercihlerinizi kalıcı olarak kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a695144166 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards: " + d["1"] + " değerinde " + d["0"] + " ödül gecenizi ve ortalama " + d["3"] + " değerindeki " + d["2"] + " puanınızı kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a279073271 = messageFormatterFn((function(  ) {
  return function(d) { return "Kredilerinizi, kuponlarınızı, kayıtlı seyahat öğelerinizi ve hesap tercihlerinizi kalıcı olarak kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1325434465 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " değerinde " + d["0"] + " CheapCash'inizi, " + d["2"] + " değerinde kredinizi, kuponlarınızı, kayıtlı seyahat öğelerinizi ve hesap tercihlerinizi kalıcı olarak kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a362919474 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " değerinde " + d["0"] + " CheapCash'inizi, kuponlarınızı, kayıtlı seyahat öğelerinizi ve hesap tercihlerinizi kalıcı olarak kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2133927209 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " değerinde " + d["0"] + " Orbucks'ınızı, " + d["2"] + " değerinde kredinizi, kuponlarınızı, kayıtlı seyahat öğelerinizi ve hesap tercihlerinizi kalıcı olarak kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1661476358 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " değerinde " + d["0"] + " Orbucks'ınızı, kuponlarınızı, kayıtlı seyahat öğelerinizi ve hesap tercihlerinizi kalıcı olarak kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a934369251 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " değerinde " + d["0"] + " MrJet Rewards'unuzu, " + d["2"] + " değerinde kredinizi, kuponlarınızı, kayıtlı seyahat öğelerinizi ve hesap tercihlerinizi kalıcı olarak kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1055458670 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " değerinde " + d["0"] + " MrJet Rewards'unuzu, kuponlarınızı, kayıtlı seyahat öğelerinizi ve hesap tercihlerinizi kalıcı olarak kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a752089663 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " değerinde " + d["0"] + " BONUS+'ınızı, " + d["2"] + " değerinde kredinizi, kuponlarınızı, kayıtlı seyahat öğelerinizi ve hesap tercihlerinizi kalıcı olarak kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1325699474 = messageFormatterFn((function(  ) {
  return function(d) { return d["1"] + " değerinde " + d["0"] + " BONUS+'ınızı, kuponlarınızı, kayıtlı seyahat öğelerinizi ve hesap tercihlerinizi kalıcı olarak kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1494755127 = messageFormatterFn((function(  ) {
  return function(d) { return "Kuponlarınızı, kayıtlı seyahat öğelerinizi ve hesap tercihlerinizi kalıcı olarak kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b21440098 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " değerinde kredinizi, kuponlarınızı, kayıtlı seyahat öğelerinizi ve hesap tercihlerinizi kalıcı olarak kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2011483688 = messageFormatterFn((function(  ) {
  return function(d) { return "Yasal yükümlülükleri yerine getirmek için veya yasal bir iddia oluşturmamız, uygulamamız veya savunma yapmamız gerektiğinde kullanmak üzere işlemlerinizin kayıtları gibi bazı bilgileri güvenli bir şekilde saklayabiliriz. Bu bilgiler güvenli bir şekilde saklanacak ve artık gerekli olmadığında silinecek, isimsizleştirilecek veya kalıcı olarak karartılacaktır."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1474897428 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesabı kalıcı olarak sil"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2135339036 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesabı silme"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b370521454 = messageFormatterFn((function(  ) {
  return function(d) { return "Tekrar görüşmek üzere"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2141316275 = messageFormatterFn((function(  ) {
  return function(d) { return "Silme talebinizin işleme alınması birkaç hafta sürebilir, bu nedenle sistemimiz güncellenene kadar iletişim almaya devam edebilirsiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1893937779 = messageFormatterFn((function(  ) {
  return function(d) { return "Lütfen tekrar deneyin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1563464908 = messageFormatterFn((function(  ) {
  return function(d) { return "Bir sistem hatası oluştu. Hesabınızın silinmesine yönelik talebinizi yeniden gönderin veya birkaç dakika içinde tekrar deneyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b624633988 = messageFormatterFn((function(  ) {
  return function(d) { return "Kapat"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1900838571 = messageFormatterFn((function(  ) {
  return function(d) { return "Seyahat kimliğinizde hangi adı kullanıyorsunuz?"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a269509979 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesaptaki adınızı, pasaport veya ehliyet gibi seyahat ederken kullandığınız kimlikle eşleştirin. Bir sonraki rezervasyonunuzda bunu hazır bulunduracağız."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a438099273 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " markasından e-posta yoluyla fırsatları, teklifleri ve diğer bilgileri alın."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b181640250 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " markasından e-posta yoluyla fırsatları, teklifleri ve diğer bilgileri alın. Pazarlama e-postaları aboneliğinden istediğiniz zaman çıkabilirsiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b423960703 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesap Bilgileri"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b933988990 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesap Bilgileri | " + d["0"]; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1571390825 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " tarafından sunulan fırsatlar, teklifler ve diğer bilgiler hakkında e-postalar alın. Dilediğiniz zaman çekilebilirsiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1263437141 = messageFormatterFn((function(  ) {
  return function(d) { return "Başlangıç | " + d["0"]; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1352638259 = messageFormatterFn((function(  ) {
  return function(d) { return "En güncel bilgilere sahip olun"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1107883309 = messageFormatterFn((function(  ) {
  return function(d) { return "Pazarlama Onayı"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b277672222 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia Rewards"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1867915200 = messageFormatterFn((function(  ) {
  return function(d) { return "CheapCash"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1444998584 = messageFormatterFn((function(  ) {
  return function(d) { return "Orbitz Rewards"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b169027360 = messageFormatterFn((function(  ) {
  return function(d) { return "BONUS+"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a911271138 = messageFormatterFn((function(  ) {
  return function(d) { return "MrJet"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b20897337 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a133544805 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2017056110 = messageFormatterFn((function(  ) {
  return function(d) { return "Üzgünüz, seyahatiniz tamamlanana kadar beklemeniz gerekiyor"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1519592574 = messageFormatterFn((function(  ) {
  return function(d) { return "Üzgünüz, yaklaşan seyahatlerinizden sonrasına kadar beklemeniz gerekiyor"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a619554172 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesabınız, rezervasyon detaylarına ve gerektiğinde desteğe erişmenizi sağlar. Lütfen seyahatinizi tamamladıktan sonra yeniden deneyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2019808360 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesabınız, rezervasyon detaylarına ve gerektiğinde desteğe erişmenizi sağlar. Lütfen seyahatleriniz tamamlandıktan sonra tekrar deneyin."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1874780129 = messageFormatterFn((function(  ) {
  return function(d) { return "Üzgünüz, hesabınız şu anda silinemiyor"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2058366517 = messageFormatterFn((function(  ) {
  return function(d) { return "Bu hesap aynı zamanda Vrbo'da konaklama yerlerini listelemek için de kullanılıyor. Hesabınızı silmeden önce, profilinizdeki aktif konaklama yerlerinizi kaldırmak için Vrbo Owner uygulamasından veya sitesinden giriş yapmanız gerekir."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a1342195460 = messageFormatterFn((function(  ) {
  return function(d) { return "Bize neden ayrıldığınızı söyleyebilir misiniz?"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1973439897 = messageFormatterFn((function(  ) {
  return function(d) { return "Başka bir e-posta adresiyle hesabım var"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b963569560 = messageFormatterFn((function(  ) {
  return function(d) { return "Olumsuz bir rezervasyon deneyimi yaşadım"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b511132483 = messageFormatterFn((function(  ) {
  return function(d) { return "Ayrıldığınız için üzgünüz. Hesabınızı silme işleminin geri alınamaz olduğunu ve Expedia, Hotels.com ve Vrbo'daki verilerinizi etkileyeceğini lütfen unutmayın. Bilmeniz gereken birkaç ayrıntıyı aşağıda bulabilirsiniz:"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1091343416 = messageFormatterFn((function(  ) {
  return function(d) { return "Ayrıldığınız için üzgünüz. Hesabınızı silme işleminin geri alınamaz olduğunu ve Expedia, Wotif, Hotels.com ve Vrbo'daki verilerinizi etkileyeceğini lütfen unutmayın. Bilmeniz gereken birkaç ayrıntıyı aşağıda bulabilirsiniz:"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a350361951 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia, Hotels.com ve Vrbo'daki hesap geçmişinizi, tercihlerinizi ve kayıtlı öğelerinizi kalıcı olarak kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2104932630 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia, Wotif, Hotels.com ve Vrbo'daki hesap geçmişinizi, tercihlerinizi ve kayıtlı öğelerinizi kalıcı olarak kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2141938605 = messageFormatterFn((function(  ) {
  return function(d) { return "Bekleyen OneKeyCash'ler de dâhil olmak üzere tüm OneKeyCash'lerin yanı sıra tüm avantajlarıyla birlikte One Key seviyenizi sonsuza dek kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a285455305 = messageFormatterFn((function(  ) {
  return function(d) { return "Bekleyen OneKeyCash'lerinizi ve tüm avantajlarıyla birlikte One Key seviyenizi sonsuza dek kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1352774590 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " değerinde OneKeyCash'i, bekleyen OneKeyCash'leri ve tüm avantajlarıyla birlikte One Key seviyenizi kalıcı olarak kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b708938028 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Ödülleri kredi kartı sahipleri artık kart faaliyetlerine göre ödüller alamayacak."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1747626063 = messageFormatterFn((function(  ) {
  return function(d) { return "Onaylanan ve bekleyen tüm Expedia Ödül puanları, Hotels.com Ödül puanları ve ödül geceleri ile ödül seviyeleri dâhil olmak üzere tüm Expedia Ödül puanlarını sonsuza kadar kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b2086681561 = messageFormatterFn((function(  ) {
  return function(d) { return "Bekleyen Expedia Rewards puanları, Hotels.com™ Rewards puanları ve ödül gecelerinin yanı sıra ödül seviyenizi kalıcı olarak kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a453521965 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia, Hotels.com veya Vrbo için olan tüm kupon ve kredilerinizi kalıcı olarak kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b83817160 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia, Wotif, Hotels.com veya Vrbo için olan tüm kupon ve kredilerinizi kalıcı olarak kaybedeceksiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b455726970 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia, Hotels.com ve Vrbo için hesap silme talebinizin işleme alınması birkaç hafta sürebilir. Bu nedenle sistemimiz güncellenirken bildirim almaya devam edebilirsiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a403250385 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia, Wotif, Hotels.com ve Vrbo için hesap silme talebinizin işleme alınması birkaç hafta sürebilir. Bu nedenle sistemimiz güncellenirken bildirim almaya devam edebilirsiniz."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1246679813 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesabınızı sildiğinizde One Key Kartınız kapanacaktır ve herhangi bir satın alma işleminde OneKeyCash kazanamayacaksınız. Wells Fargo, kartınızın kapatılmasına dair onay ile ilgili olarak sizinle irtibata geçecektir."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b985906161 = messageFormatterFn((function(  ) {
  return function(d) { return "Hesabınızı sildiğinizde One Key+ Kartınız kapanacaktır ve herhangi bir satın alma işleminde OneKeyCash kazanamayacaksınız. Wells Fargo, kartınızın kapatılmasına dair onay ile ilgili olarak sizinle irtibata geçecektir."; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b1509473668 = messageFormatterFn((function(  ) {
  return function(d) { return "Seyahatiniz için OneKeyCash kazanmak isterseniz giriş yapın veya bir hesap oluşturun"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a2103898334 = messageFormatterFn((function(  ) {
  return function(d) { return "Bu konaklamada ödüller kazanmak için giriş yapın veya bir hesap oluşturun"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b770474757 = messageFormatterFn((function(  ) {
  return function(d) { return "Misafir olarak ödeme yapın"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b440131341 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " Hesap Giriş Bilgileri: Mobil Cihaz Ekleyin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.a49224669 = messageFormatterFn((function(  ) {
  return function(d) { return "Bir sorun oluştu"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b754767031 = messageFormatterFn((function(  ) {
  return function(d) { return "Tekrar giriş yapmayı deneyin"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b988336576 = messageFormatterFn((function(  ) {
  return function(d) { return "Tamam"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b904874631 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " logosu"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b61508852 = messageFormatterFn((function(  ) {
  return function(d) { return "Başlangıç"; }
})(), Globalize("tr-TR").pluralGenerator({}));
Globalize.b825985416 = dateToPartsFormatterFn({"2":Globalize("tr-TR").numberFormatter({"raw":"00"}),"4":Globalize("tr-TR").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.b1940531784 = dateToPartsFormatterFn({"2":Globalize("tr-TR").numberFormatter({"raw":"00"}),"4":Globalize("tr-TR").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b79245301 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"}),"4":Globalize("tr-TR").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.b1201699259 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"}),"4":Globalize("tr-TR").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.b1886390760 = dateToPartsFormatterFn({"2":Globalize("tr-TR").numberFormatter({"raw":"00"}),"4":Globalize("tr-TR").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.b1625542131 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"}),"4":Globalize("tr-TR").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.b88668744 = dateToPartsFormatterFn({"2":Globalize("tr-TR").numberFormatter({"raw":"00"}),"4":Globalize("tr-TR").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.b1832249736 = dateToPartsFormatterFn({"2":Globalize("tr-TR").numberFormatter({"raw":"00"}),"4":Globalize("tr-TR").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.b1302755464 = dateToPartsFormatterFn({"2":Globalize("tr-TR").numberFormatter({"raw":"00"}),"4":Globalize("tr-TR").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b320816693 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"}),"4":Globalize("tr-TR").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.a1690156568 = dateToPartsFormatterFn({"2":Globalize("tr-TR").numberFormatter({"raw":"00"}),"4":Globalize("tr-TR").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b968257817 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"P","mon":"P","tue":"S","wed":"Ç","thu":"P","fri":"C","sat":"C"}}}});
Globalize.a107282360 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"Pazar","mon":"Pazartesi","tue":"Salı","wed":"Çarşamba","thu":"Perşembe","fri":"Cuma","sat":"Cumartesi"}}}});
Globalize.b1145963080 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"Ocak","2":"Şubat","3":"Mart","4":"Nisan","5":"Mayıs","6":"Haziran","7":"Temmuz","8":"Ağustos","9":"Eylül","10":"Ekim","11":"Kasım","12":"Aralık"}}}});
Globalize.b840768984 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.b49579221 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"}),"2":Globalize("tr-TR").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a1764992950 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"})}, {"pattern":"d MMM","timeSeparator":":","months":{"M":{"3":{"1":"Oca","2":"Şub","3":"Mar","4":"Nis","5":"May","6":"Haz","7":"Tem","8":"Ağu","9":"Eyl","10":"Eki","11":"Kas","12":"Ara"}}}});
Globalize.b1139154541 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM","timeSeparator":":","months":{"M":{"4":{"1":"Ocak","2":"Şubat","3":"Mart","4":"Nisan","5":"Mayıs","6":"Haziran","7":"Temmuz","8":"Ağustos","9":"Eylül","10":"Ekim","11":"Kasım","12":"Aralık"}}}});
Globalize.a1102968706 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"Ocak","2":"Şubat","3":"Mart","4":"Nisan","5":"Mayıs","6":"Haziran","7":"Temmuz","8":"Ağustos","9":"Eylül","10":"Ekim","11":"Kasım","12":"Aralık"}}}});
Globalize.b1765596322 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"})}, {"pattern":"MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"Ocak","2":"Şubat","3":"Mart","4":"Nisan","5":"Mayıs","6":"Haziran","7":"Temmuz","8":"Ağustos","9":"Eylül","10":"Ekim","11":"Kasım","12":"Aralık"}}}});
Globalize.b1764911129 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"})}, {"pattern":"d MMM y","timeSeparator":":","months":{"M":{"3":{"1":"Oca","2":"Şub","3":"Mar","4":"Nis","5":"May","6":"Haz","7":"Tem","8":"Ağu","9":"Eyl","10":"Eki","11":"Kas","12":"Ara"}}}});
Globalize.a428799222 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM EEEE","timeSeparator":":","months":{"M":{"4":{"1":"Ocak","2":"Şubat","3":"Mart","4":"Nisan","5":"Mayıs","6":"Haziran","7":"Temmuz","8":"Ağustos","9":"Eylül","10":"Ekim","11":"Kasım","12":"Aralık"}}},"days":{"E":{"4":{"sun":"Pazar","mon":"Pazartesi","tue":"Salı","wed":"Çarşamba","thu":"Perşembe","fri":"Cuma","sat":"Cumartesi"}}}});
Globalize.b1146542709 = dateToPartsFormatterFn({"1":Globalize("tr-TR").numberFormatter({"raw":"0"})}, {"pattern":"d MMMM E","timeSeparator":":","months":{"M":{"4":{"1":"Ocak","2":"Şubat","3":"Mart","4":"Nisan","5":"Mayıs","6":"Haziran","7":"Temmuz","8":"Ağustos","9":"Eylül","10":"Ekim","11":"Kasım","12":"Aralık"}}},"days":{"E":{"1":{"sun":"Paz","mon":"Pzt","tue":"Sal","wed":"Çar","thu":"Per","fri":"Cum","sat":"Cmt"}}}});
Globalize.b447271665 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.b1561818033 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a1735671906 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.a613217948 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.b1507677009 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.a189375076 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a290045007 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.b1453535985 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b924041713 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.a1494100514 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.a2068870319 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b1119431184 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.b728878193 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.b1982123633 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b257485391 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"d"}));
Globalize.b440986302 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.b2102115777 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.b760440790 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.b41806901 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.b1386882571 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.b1386197378 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.b188931329 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b767828958 = dateFormatterFn(Globalize("tr-TR").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a1166790078 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.a52243710 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.a946290897 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b176163061 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.a106384734 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.b600005933 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a1904106750 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a160525758 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.a690020030 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.a704719505 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b612035234 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a686703585 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^P/],["mon",/^P/],["tue",/^S/],["wed",/^Ç/],["thu",/^P/],["fri",/^C/],["sat",/^C/]]});
Globalize.b1640447106 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["mon",/^Pazartesi/],["sat",/^Cumartesi/],["wed",/^Çarşamba/],["thu",/^Perşembe/],["sun",/^Pazar/],["tue",/^Salı/],["fri",/^Cuma/]]});
Globalize.a1401274750 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["6",/^Haziran/],["8",/^Ağustos/],["7",/^Temmuz/],["12",/^Aralık/],["2",/^Şubat/],["4",/^Nisan/],["5",/^Mayıs/],["9",/^Eylül/],["11",/^Kasım/],["1",/^Ocak/],["3",/^Mart/],["10",/^Ekim/]]});
Globalize.b1815272414 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.b285383311 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b803123280 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^Oca/],["2",/^Şub/],["3",/^Mar/],["4",/^Nis/],["5",/^May/],["6",/^Haz/],["7",/^Tem/],["8",/^Ağu/],["9",/^Eyl/],["10",/^Eki/],["11",/^Kas/],["12",/^Ara/]]});
Globalize.a853620953 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["6",/^Haziran/],["8",/^Ağustos/],["7",/^Temmuz/],["12",/^Aralık/],["2",/^Şubat/],["4",/^Nisan/],["5",/^Mayıs/],["9",/^Eylül/],["11",/^Kasım/],["1",/^Ocak/],["3",/^Mart/],["10",/^Ekim/]]});
Globalize.b1545500420 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["6",/^Haziran/],["8",/^Ağustos/],["7",/^Temmuz/],["12",/^Aralık/],["2",/^Şubat/],["4",/^Nisan/],["5",/^Mayıs/],["9",/^Eylül/],["11",/^Kasım/],["1",/^Ocak/],["3",/^Mart/],["10",/^Ekim/]]});
Globalize.a227179172 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["6",/^Haziran/],["8",/^Ağustos/],["7",/^Temmuz/],["12",/^Aralık/],["2",/^Şubat/],["4",/^Nisan/],["5",/^Mayıs/],["9",/^Eylül/],["11",/^Kasım/],["1",/^Ocak/],["3",/^Mart/],["10",/^Ekim/]]});
Globalize.a227864365 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^Oca/],["2",/^Şub/],["3",/^Mar/],["4",/^Nis/],["5",/^May/],["6",/^Haz/],["7",/^Tem/],["8",/^Ağu/],["9",/^Eyl/],["10",/^Eki/],["11",/^Kas/],["12",/^Ara/]]});
Globalize.b2129391632 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM EEEE","digitsRe":/\d/,"gregorian/months/format/wide":[["6",/^Haziran/],["8",/^Ağustos/],["7",/^Temmuz/],["12",/^Aralık/],["2",/^Şubat/],["4",/^Nisan/],["5",/^Mayıs/],["9",/^Eylül/],["11",/^Kasım/],["1",/^Ocak/],["3",/^Mart/],["10",/^Ekim/]],"gregorian/days/format/wide":[["mon",/^Pazartesi/],["sat",/^Cumartesi/],["wed",/^Çarşamba/],["thu",/^Perşembe/],["sun",/^Pazar/],["tue",/^Salı/],["fri",/^Cuma/]]});
Globalize.a846232785 = dateParserFn(Globalize("tr-TR").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d MMMM E","digitsRe":/\d/,"gregorian/months/format/wide":[["6",/^Haziran/],["8",/^Ağustos/],["7",/^Temmuz/],["12",/^Aralık/],["2",/^Şubat/],["4",/^Nisan/],["5",/^Mayıs/],["9",/^Eylül/],["11",/^Kasım/],["1",/^Ocak/],["3",/^Mart/],["10",/^Ekim/]],"gregorian/days/format/abbreviated":[["sun",/^Paz/],["mon",/^Pzt/],["tue",/^Sal/],["wed",/^Çar/],["thu",/^Per/],["fri",/^Cum/],["sat",/^Cmt/]]});
module.exports = Globalize;
